import React from "react";

import { Box, Divider } from "@origin-digital/ods-core";

import { IKrakenNavLink } from "../interfaces";
import { NavLinkBase, NavLinkIndentation } from "../NavLinkBase";

interface IMobileNavLinkContainer extends IKrakenNavLink {
  onClick?: (e: React.KeyboardEvent | React.MouseEvent) => void;
  indent?: NavLinkIndentation;
  isOpen?: boolean;
}

export const MobileNavLinkContainer = (props: IMobileNavLinkContainer) => {
  const { onClick, ...linkProps } = props;

  return (
    <Box onClick={onClick}>
      <Divider />
      <Box>
        <NavLinkBase mobile={true} {...linkProps} />
      </Box>
    </Box>
  );
};
